import { TimelineItem } from 'dynamo-daos/build/models/projects/projectRecord';

import {
  BackgroundSettingsV1,
  CameraSettingsV1,
  CharacterSettingsV1,
  LabelSettingsV1,
  PlaybackSettingsV1,
  ProjectFromAPI,
  ProjectType,
} from '../types';
import { transformProjectResponse } from './api-transforms';
import apiRequest from './apiRequest';

type ProjectPostPayload = {
  characters: Record<
    string,
    {
      characterID: string;
      instanceID: string;
      timeline: TimelineItem[];
    }
  >;
  projectName: string;
  sceneSettings: {
    backgroundSettings?: BackgroundSettingsV1;
    cameraSettings?: CameraSettingsV1;
    characterSettings?: CharacterSettingsV1;
    labelSettings?: LabelSettingsV1;
    playbackSettings?: PlaybackSettingsV1;
  };
  type: ProjectType;
};

export default async function postProject(props: ProjectPostPayload) {
  const { data, error } = await apiRequest<ProjectFromAPI>(
    'mogen-orchestration',
    '/v2/projects',
    {
      method: 'POST',
      body: JSON.stringify(props),
    },
  );

  return {
    data: data ? transformProjectResponse(data) : undefined,
    error,
  };
}
